import { Navigate } from 'react-router-dom';
import { useAuth } from '../App';

/**
 * ProtectedRoute
 * Guards routes based on authentication status and user roles.
 * 
 * @param {Object} props
 * @param {React.ReactNode} props.children - The component to render if authorized
 * @param {Array<string>} props.roles - Allowed roles for this route
 */
const ProtectedRoute = ({ children, roles }) => {
    const { isAuthenticated, user, loading } = useAuth();

    if (loading) {
        return (
            <div className="flex items-center justify-center" style={{ minHeight: '100vh' }}>
                <div className="spinner"></div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" />;
    }

    if (roles && !roles.includes(user.role)) {
        // Redirect to their default dashboard if they don't have permission
        return <Navigate to="/" />;
    }

    return children;
};

export default ProtectedRoute;
